// extracted by mini-css-extract-plugin
export default {"column":"gD3pAPZ03dTfPaV6KbQa","title":"qLVMLIDAoyNTKxJgy9dx"};